import React from "react";

export default function RecruiterSettingsSubscriptionPage() {
  return <div>RecruiterSettingsSubscriptionPage</div>;
}
